export const normalizeFolderNumber = value => {
  if (typeof value !== 'string') return '';
  try {
    const number = decodeURIComponent(value).trim();
    return /^[0-9]+$/.test(number) ? number : '';
  } catch {
    return '';
  }
};
